import(/* webpackMode: "eager" */ "/snv/app/[locale]/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/category/CategoryContentList.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/category/CategoryTags.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/category/ClassificationList.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/TranslationsProvider.js");
;
import(/* webpackMode: "eager" */ "/snv/node_modules/next/dist/client/image-component.js");
